<template>
<div>
  <van-nav-bar
      title="活动中心"
      left-text=""
      left-arrow
      @click-left="onClickLeft()"
    >
  </van-nav-bar>
  <div class="arrow_box">
    <div style="text-align:right;margin-top:3%;margin-right:10px;">
      <van-tag mark type="primary" size="large" @click="toRewardLog()">领取记录</van-tag>
    </div>
    <div style="text-align:right;margin-top:2%;margin-right:10px;">
      <van-tag mark type="primary" size="large" @click="toRule()">活动规则</van-tag>
    </div>
    <div style="text-align:center;margin-top:22%;height:35px;">
      <img class="image" src="../assets/draw2023/contract_bg1.png" @click="onContract()">
    </div>
    <div style="margin-top:1%;text-align:center;">
      <van-tag round plain type="danger" style="font-size:15px;">本阶段已领 {{reward}} 积分</van-tag>
    </div>
    <div style="margin-top:5%;">
      <van-swipe :loop="false" :width="175" :show-indicators="true">
        <van-swipe-item style="margin-left:1%;">
          <img src="../assets/draw2023/no_task68.png" v-if="isCurrent3==1" />
          <img src="../assets/draw2023/task68.png" @click="receive2(1)" v-if="isCurrent3==0" />
          <div style="width:100px;margin-top:-106px;margin-left:75px;font-size:14px;color:#98979a;" v-if="isCurrent3==1">已领取</div>
          <div style="width:100px;margin-top:-106px;margin-left:75px;font-size:14px;color:#a5a3ee;" v-if="isCurrent3==0&&myCount>=3">可领取</div>
          <div style="width:100px;margin-top:-106px;margin-left:75px;font-size:14px;color:#a5a3ee;" v-if="isCurrent3==0&&myCount<3">再完成{{3-myCount}}单</div>
        </van-swipe-item>
        <van-swipe-item>
          <img src="../assets/draw2023/no_task148.png" v-if="isCurrent6==1" />
          <img src="../assets/draw2023/task148.png" @click="receive2(2)" v-if="isCurrent6==0" />
          <div style="width:100px;margin-top:-106px;margin-left:75px;font-size:14px;color:#98979a;" v-if="isCurrent3==1&&isCurrent6==1">已领取</div>
          <div style="width:100px;margin-top:-106px;margin-left:75px;font-size:14px;color:#f1b369;" v-if="isCurrent3==1&&isCurrent6==0&&myCount>=6">可领取</div>
          <div style="width:100px;margin-top:-106px;margin-left:75px;font-size:14px;color:#f1b369;" v-if="isCurrent3==1&&isCurrent6==0&&myCount<6">再完成{{6-myCount}}单</div>
        </van-swipe-item>
        <van-swipe-item>
          <img src="../assets/draw2023/no_task288.png" v-if="isCurrent10==1" />
          <img src="../assets/draw2023/task288.png" @click="receive2(3)" v-if="isCurrent10==0" />
          <div style="width:100px;margin-top:-106px;margin-left:75px;font-size:14px;color:#98979a;" v-if="isCurrent3==1&&isCurrent6==1&&isCurrent10==1">已领取</div>
          <div style="width:100px;margin-top:-106px;margin-left:75px;font-size:14px;color:#65b39b;" v-if="isCurrent3==1&&isCurrent6==1&&isCurrent10==0&&myCount>=10">可领取</div>
          <div style="width:100px;margin-top:-106px;margin-left:75px;font-size:14px;color:#65b39b;" v-if="isCurrent3==1&&isCurrent6==1&&isCurrent10==0&&myCount<10">再完成{{10-myCount}}单</div>
        </van-swipe-item>
        <van-swipe-item>
          <img src="../assets/draw2023/no_task388.png"  v-if="isCurrent15==1" />
          <img src="../assets/draw2023/task388.png" @click="receive2(4)" v-if="isCurrent15==0" />
          <div style="width:100px;margin-top:-106px;margin-left:75px;font-size:14px;color:#98979a;" v-if="isCurrent3==1&&isCurrent6==1&&isCurrent10==1&&isCurrent15==1">已领取</div>
          <div style="width:100px;margin-top:-106px;margin-left:75px;font-size:14px;color:#9aafd7;" v-if="isCurrent3==1&&isCurrent6==1&&isCurrent10==1&&isCurrent15==0&&myCount>=15">可领取</div>
          <div style="width:100px;margin-top:-106px;margin-left:75px;font-size:14px;color:#9aafd7;" v-if="isCurrent3==1&&isCurrent6==1&&isCurrent10==1&&isCurrent15==0&&myCount<15">再完成{{15-myCount}}单</div>
        </van-swipe-item>
        <van-swipe-item>
          <img src="../assets/draw2023/no_task888.png" v-if="isCurrent24==1" />
          <img src="../assets/draw2023/task888.png" @click="receive2(5)" v-if="isCurrent24==0" />
          <div style="width:100px;margin-top:-106px;margin-left:75px;font-size:14px;color:#98979a;" v-if="isCurrent3==1&&isCurrent6==1&&isCurrent10==1&&isCurrent15==1&&isCurrent24==1">已领取</div>
          <div style="width:100px;margin-top:-106px;margin-left:75px;font-size:14px;color:#ff97c7;" v-if="isCurrent3==1&&isCurrent6==1&&isCurrent10==1&&isCurrent15==1&&isCurrent24==0&&myCount>=24">可领取</div>
          <div style="width:100px;margin-top:-106px;margin-left:75px;font-size:14px;color:#ff97c7;" v-if="isCurrent3==1&&isCurrent6==1&&isCurrent10==1&&isCurrent15==1&&isCurrent24==0&&myCount<24">再完成{{24-myCount}}单</div>
          </van-swipe-item>
        <van-swipe-item>
          <img src="../assets/draw2023/no_task1088.png" v-if="isCurrent35==1" />
          <img src="../assets/draw2023/task1088.png" @click="receive2(6)" v-if="isCurrent35==0" />
          <div style="width:100px;margin-top:-106px;margin-left:75px;font-size:14px;color:#98979a;" v-if="isCurrent3==1&&isCurrent6==1&&isCurrent10==1&&isCurrent15==1&&isCurrent24==1&&isCurrent35==1">已领取</div>
          <div style="width:100px;margin-top:-106px;margin-left:75px;font-size:14px;color:#75917f;" v-if="isCurrent3==1&&isCurrent6==1&&isCurrent10==1&&isCurrent15==1&&isCurrent24==1&&isCurrent35==0&&myCount>=35">可领取</div>
          <div style="width:100px;margin-top:-106px;margin-left:75px;font-size:14px;color:#75917f;" v-if="isCurrent3==1&&isCurrent6==1&&isCurrent10==1&&isCurrent15==1&&isCurrent24==1&&isCurrent35==0&&myCount<35">再完成{{35-myCount}}单</div>
        </van-swipe-item>
        <van-swipe-item>
          <img src="../assets/draw2023/no_task2088.png" v-if="isCurrent55==1" />
          <img src="../assets/draw2023/task2088.png" @click="receive2(7)" v-if="isCurrent55==0" />
          <div style="width:100px;margin-top:-106px;margin-left:75px;font-size:14px;color:#98979a;" v-if="isCurrent3==1&&isCurrent6==1&&isCurrent10==1&&isCurrent15==1&&isCurrent24==1&&isCurrent35==1&&isCurrent55==1">已领取</div>
          <div style="width:100px;margin-top:-106px;margin-left:75px;font-size:14px;color:#fdb52b;" v-if="isCurrent3==1&&isCurrent6==1&&isCurrent10==1&&isCurrent15==1&&isCurrent24==1&&isCurrent35==1&&isCurrent55==0&&myCount>=55">可领取</div>
          <div style="width:100px;margin-top:-106px;margin-left:75px;font-size:14px;color:#fdb52b;" v-if="isCurrent3==1&&isCurrent6==1&&isCurrent10==1&&isCurrent15==1&&isCurrent24==1&&isCurrent35==1&&isCurrent55==0&&myCount<55">再完成{{55-myCount}}单</div>
        </van-swipe-item>
        <van-swipe-item>
          <img src="../assets/draw2023/no_task2888.png" v-if="isCurrent80==1" />
          <img src="../assets/draw2023/task2888.png" @click="receive2(8)" v-if="isCurrent80==0" />
          <div style="width:100px;margin-top:-106px;margin-left:75px;font-size:14px;color:#98979a;" v-if="isCurrent3==1&&isCurrent6==1&&isCurrent10==1&&isCurrent15==1&&isCurrent24==1&&isCurrent35==1&&isCurrent55==1&&isCurrent80==1">已领取</div>
          <div style="width:100px;margin-top:-106px;margin-left:75px;font-size:14px;color:#ff7e7e;" v-if="isCurrent3==1&&isCurrent6==1&&isCurrent10==1&&isCurrent15==1&&isCurrent24==1&&isCurrent35==1&&isCurrent55==1&&isCurrent80==0&&myCount>=80">可领取</div>
          <div style="width:100px;margin-top:-106px;margin-left:75px;font-size:14px;color:#ff7e7e;" v-if="isCurrent3==1&&isCurrent6==1&&isCurrent10==1&&isCurrent15==1&&isCurrent24==1&&isCurrent35==1&&isCurrent55==1&&isCurrent80==0&&myCount<80">再完成{{80-myCount}}单</div>
        </van-swipe-item>
      </van-swipe>
    </div>
  </div>
    
  <div style="margin-top:10px;">
    <van-cell-group inset style="margin-top:5px;margin-left:5px;margin-right:5px;" 
          v-for="(item,idx) in taskList" v-bind:key="idx">
      <van-cell :title="item.TaskType" value="" />
      <van-cell :title="item.Title" value="内容" :label="item.Describe" style="margin-top:5px;margin-bottom:5px;" 
            title-style="font-size:14px;font-weight:bold;padding-left:5px;">
        <!--连续任务1-->
        <div v-if="item.ID==6&&task1Count==1">
          <van-button type="danger" round size="mini" @click="receive(item.ID)" disabled>已领取</van-button>
        </div>
        <div v-else-if="item.ID==6&&task1Count==0&&task1Process<100">
          <van-button type="danger" round size="mini" @click="receive(item.ID)" disabled>等待领取</van-button>
        </div>
        <!--连续任务2-->
        <div v-else-if="item.ID==7&&task2Count==1">
          <van-button type="danger" round size="mini" @click="receive(item.ID)" disabled>已领取</van-button>
        </div>
        <div v-else-if="item.ID==7&&task2Count==0&&task2Process<100">
          <van-button type="danger" round size="mini" @click="receive(item.ID)" disabled>等待领取</van-button>
        </div>
        <!--连续任务3-->
        <div v-else-if="item.ID==8&&task3Count==1">
          <van-button type="danger" round size="mini" @click="receive(item.ID)" disabled>已领取</van-button>
        </div>
        <div v-else-if="item.ID==8&&task3Count==0&&task3Process<100">
          <van-button type="danger" round size="mini" @click="receive(item.ID)" disabled>等待领取</van-button>
        </div>
        <!--红宝石任务-->
        <div v-else-if="item.ID==9&&rubyProcess<100">
          <van-button type="danger" round size="mini" @click="receive(item.ID)" disabled>等待领取</van-button>
        </div>
        <!--配套产品任务-->
        <div v-else-if="item.ID==10&&otherProductProcess<100">
          <van-button type="danger" round size="mini" @click="receive(item.ID)" disabled>等待领取</van-button>
        </div>
        <div v-else>
          <van-button type="danger" round size="mini" @click="receive(item.ID)">立即领取</van-button>
        </div>
        <!-- 使用 icon 插槽来自定义左侧图标 -->
        <template #icon>
          <img width="40" height="45" src="../assets/draw2023/task1_icon1.png" alt="" style="margin-top:5px;" v-if="item.ID==6">
          <img width="40" height="45" src="../assets/draw2023/task3_icon1.png" alt="" style="margin-top:5px;" v-if="item.ID==7">
          <img width="40" height="45" src="../assets/draw2023/task4_icon1.png" alt="" style="margin-top:5px;" v-if="item.ID==8">
          <img width="40" height="45" src="../assets/draw2023/task3_icon1.png" alt="" style="margin-top:5px;" v-if="item.ID==9">
          <img width="40" height="45" src="../assets/draw2023/task2_icon1.png" alt="" style="margin-top:5px;" v-if="item.ID==10">
        </template>
      </van-cell>
      <!--任务进度-->
      <div style="width:90%;margin-left:5%;margin-right:5%;padding-bottom:5px;" v-if="item.ID==6">
        <van-progress color="#f2826a" :percentage="task1Process" :stroke-width="3"/>
      </div>
      <div style="width:90%;margin-left:5%;margin-right:5%;padding-bottom:5px;" v-if="item.ID==7">
        <van-progress color="#f2826a" :percentage="task2Process" :stroke-width="3"/>
      </div>
      <div style="width:90%;margin-left:5%;margin-right:5%;padding-bottom:5px;" v-if="item.ID==8">
        <van-progress color="#f2826a" :percentage="task3Process" :stroke-width="3"/>
      </div>
      <div style="width:90%;margin-left:5%;margin-right:5%;padding-bottom:5px;" v-if="item.ID==9">
        <van-progress color="#f2826a" :percentage="rubyProcess" :stroke-width="3"/>
      </div>
      <div style="width:90%;margin-left:5%;margin-right:5%;padding-bottom:5px;" v-if="item.ID==10">
        <van-progress color="#f2826a" :percentage="otherProductProcess" :stroke-width="3"/>
      </div>

    </van-cell-group>

  </div>
</div>
  
</template>
<script>
import { Button, Cell, CellGroup, NavBar, NoticeBar, Progress, Tag,Image, Swipe, SwipeItem } from "vant";
export default {
  data() {
    return {
      rankText: "",
      reward: 0,
      reText: "",
      myCount: 0,
      taskList: [],
      rubyProcess:0,
      otherProductProcess:0,
      task1Process:0,
      task2Process:0,
      task3Process:0,
      task1Count:0,
      task2Count:0,
      task3Count:0,
      isCurrent3:0,
      isCurrent6:0,
      isCurrent10:0,
      isCurrent15:0,
      isCurrent24:0,
      isCurrent35:0,
      isCurrent55:0,
      isCurrent80:0,
    };
  },
  created() {
    console.log(this.$route)
    if(this.$route.params.fromWechat){
      this.$router.go(0);
    }
    this.GetData();
    this.QueryProcess();
    this.QueryReward();
  },
  computed: {
    isLogined() {
      return this.$store.state.isLogin;
    },
  },
  methods: {
    QueryReward() {
      var that = this;
      that.$http.get("Activity/QueryReward2Num", {
          params: {},
        }).then((res) => {
          if (res.data.Msg == "success") 
          {
            that.reward=res.data.Data.Reward;
            that.myCount=res.data.Data.MyCount;
            that.isCurrent3=res.data.Data.IsCurrent3;
            that.isCurrent6=res.data.Data.IsCurrent6;
            that.isCurrent10=res.data.Data.IsCurrent10;
            that.isCurrent15=res.data.Data.IsCurrent15;
            that.isCurrent24=res.data.Data.IsCurrent24;
            that.isCurrent35=res.data.Data.IsCurrent35;
            that.isCurrent55=res.data.Data.IsCurrent55;
            that.isCurrent80=res.data.Data.IsCurrent80;
          } else {
            that.$toast(res.data);
          }
        });
    },
    receive(id) {
      var that = this;
      that.$http.get("Activity/GetUserActivity2Period2023", {
          params: {
            taskId:id
          },
        })
        .then((res) => {
          if (res.data == "success") {
            that.$toast("领取成功！");
            that.QueryReward();
            that.QueryProcess();        
          } else {
            that.$toast(res.data);
          }
        });
    },
    receive2(typeid) {
      var that = this;
      that.$http.get("Activity/Draw2Accrue2023", {
          params: {typeId:typeid},
        })
        .then((res) => {
          if (res.data == "success") {
            that.$toast("领取成功！");  
            that.QueryReward();        
          } else {
            that.$toast(res.data);
          }
        });
    },
    GetData() {
      var that = this;
      this.$http.get("Activity/GetTaskList", {
        params: {
          period:2,
          pageIndex: 1,
        },
      }).then((res) => {
        that.taskList = res.data.ListData;
        that.$toast.clear();
      });
    },
    QueryProcess() {
      var that = this;
      that.$http.get("Activity/QueryProcess2Num", {
          params: {},
        }).then((res) => {
          if (res.data.Msg == "success") 
          {
            that.rubyProcess=res.data.Data.RubyProcess;  
            that.otherProductProcess=res.data.Data.OtherProductProcess;
            that.task1Process=res.data.Data.Task1Process;
            that.task2Process=res.data.Data.Task2Process;
            that.task3Process=res.data.Data.Task3Process;
            that.task1Count=res.data.Data.Task1Count;
            that.task2Count=res.data.Data.Task2Count;
            that.task3Count=res.data.Data.Task3Count;
          } else {
            that.$toast(res.data);
          }
        });
    },
    onContract() {
      if (!this.isLogined) {
        return this.$toast.fail("您还未登录");
      }
      this.$router.push({
        name: "contract",
        params: {},
      });
    },
    toRewardLog() {
      if (!this.isLogined) {
        return this.$toast.fail("您还未登录");
      }
      this.$router.push({
        name: "Reward2LogList",
        params: {},
      });
    },
    toRule() {
      if (!this.isLogined) {
        return this.$toast.fail("您还未登录");
      }
      this.$router.push({
        name: "ActivityRule",
        params: {},
      });
    },
    onClickLeft() {
      this.$router.back(-1);
    },
  },
  components: {
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Button.name]: Button,
    [Tag.name]: Tag,
    [NoticeBar.name]: NoticeBar,
    [NavBar.name]: NavBar,
    [Progress.name]: Progress,
    [Image.name]: Image,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
  },
};
</script>
<style scoped>
.arrow_box{
  width: 98%;
  /* height: 62%; */
  /* border-radius: 5px; */
  /* background: rgba(255, 0, 0, 0.5); */
  background: white;
  position: relative;
  margin-left: 1%;
  margin-top: 10px;
  background: url('../assets/draw2023/bg_7.jpg');
  background-repeat:no-repeat;
  overflow: hidden;
  background-size: cover;
}


.image
{
  width:177px;
  height:35px;
  position:relative; 
}

@keyframes flicker{
0%,100%{
transform:scale(1);
-moz-transform:scale(1);
-o-transform:scale(1);
-webkit-transform:scale(1);
-ms-transform:scale(1);
opacity:1
}
90%{
transform:scale(0.9);
-moz-transform:scale(0.9);
-o-transform:scale(0.9);
-webkit-transform:scale(0.9);
-ms-transform:scale(0.9);
opacity:1
}

}
@-webkit-keyframes flicker{
0%,100%{
-webkit-transform:scale(1);
-moz-transform:scale(1);
-o-transform:scale(1);
-ms-transform:scale(1);
transform:scale(1);
opacity:1
}
90%{
-webkit-transform:scale(0.9);
-moz-transform:scale(0.9);
-o-transform:scale(0.9);
-ms-transform:scale(0.9);
transform:scale(0.9);
opacity:1
}

}
@-moz-keyframes flicker{
0%,100%{
-moz-transform:scale(1);
-o-transform:scale(1);
-webkit-transform:scale(1);
-ms-transform:scale(1);
transform:scale(1);
opacity:1
}
90%{
-moz-transform:scale(0.9);
-o-transform:scale(0.9);
-webkit-transform:scale(0.9);
-ms-transform:scale(0.9);
transform:scale(0.9);
opacity:1
}

}
@-o-keyframes flicker{
0%,100%{
-o-transform:scale(1);
-moz-transform:scale(1);
-webkit-transform:scale(1);
-ms-transform:scale(1);
transform:scale(1);
opacity:1
}
90%{
-o-transform:scale(0.9);
-moz-transform:scale(0.9);
-webkit-transform:scale(0.9);
-ms-transform:scale(0.9);
transform:scale(0.9);
opacity:1
}

}
.image {
-webkit-animation:flicker 0.8s infinite ease-in-out;
-moz-animation:flicker 0.8s infinite ease-in-out;
-o-animation:flicker 0.8s infinite ease-in-out;
animation:flicker 0.8s infinite ease-in-out
}
.image {
animation-delay:-0.8s;
-webkit-animation-delay:-0.8s;
-moz-animation-delay:-0.8s;
-o-animation-delay:-0.8s
}
/* .arrow{
  width: 0;
  height: 0;
  border-width: 10px;
  border-style: solid;
  border-color: transparent transparent rgba(255, 255, 255, 1) transparent;
  position: absolute;
  bottom: 0px;
  left: 80px;
} */
</style>
